import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// La type scale du DS (text-display-xl…text-micro) partage le préfixe `text-` avec les couleurs de texte
// (text-fg…). Sans le lui dire, tailwind-merge classe nos tailles comme des COULEURS → une utility de
// taille et une de couleur sur le même atome s'écrasent (la dernière gagne, la taille saute). On enregistre
// donc nos clés de taille dans le groupe `font-size` : taille et couleur deviennent orthogonales (FR2 au
// niveau merge), et deux tailles concurrentes se résolvent correctement (la dernière gagne, comme attendu).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["display-xl", "display", "section", "title", "subtitle", "body-lg", "body", "micro"] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
